import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import './style.css';

const ChatSimulator = ({
  chatHistory,
  setChatHistory,
  currentNode,
  parentNode,
  handleUserChoice,
  handleBack,
  messagesEndRef
}) => {
  const [showShopOwnerDialog, setShowShopOwnerDialog] = useState(false);

  const handleShopOwnerClick = () => {
    setShowShopOwnerDialog(true);
    setChatHistory(prev => [
      ...prev,
      { type: 'user', text: '💬 Talk to shop representative' },
      { type: 'bot', text: 'Sure! Connecting you to the shop owner now...' }
    ]);
  };

  const renderReplies = () => {
    const hasChildren = currentNode?.children && currentNode.children.length > 0;

    if (hasChildren) {
      return (
        <div className="quick-replies-simulation">
          <div className="quick-replies-title">Choose one of the options below:</div>
          {currentNode.children.map(child => (
            <Button
              key={child.key}
              label={child.data.question}
              className="p-button-sm  p-button-text"
              onClick={() => handleUserChoice(child)}
            />
          ))}
          {currentNode.key !== '0' && (
            <Button
              label="⬅️ Back to previous"
              className="p-button-sm p-button-outlined"
              onClick={handleBack}
            />
          )}
          <Button
            label="💬 Talk to shop representative"
            className="p-button-sm p-button-help p-button-primary"
            onClick={handleShopOwnerClick}
          />
        </div>
      );
    }

    return (
      <div className="quick-replies-simulation">
        <div className="quick-replies-title">Choose one of the options below:</div>
        {currentNode?.key !== '0' && (
          <Button
            label="⬅️ Back to previous"
            className="p-button-sm p-button-secondary"
            onClick={handleBack}
          />
        )}
        <Button
          label="💬 Talk to shop representative"
          className="p-button-sm p-button-help p-button-primary"
          onClick={handleShopOwnerClick}
        />
      </div>
    );
  };

  return (
    <div className="panel chat-panel">
      <Dialog
        visible={showShopOwnerDialog}
        onHide={() => setShowShopOwnerDialog(false)}
        header="Shop Owner Request"
        style={{ width: '30vw' }}
      >
        <div className="p-dialog-content">
          <p>The shopper is out of bound of this journey and would like to talk to you directly</p>
        </div>
        <div className="p-dialog-footer">
          <Button
            label="Close"
            icon="pi pi-times"
            onClick={() => setShowShopOwnerDialog(false)}
            className="p-button-text"
          />
        </div>
      </Dialog>

      <div className="chat-journey-messages-container">
        {chatHistory.map((msg, idx) => (
          <div key={idx} className={`message-wrapper ${msg.type === 'user' ? 'current-user' : ''}`}>
            <div className={`message-bubble ${msg.type === 'user' ? 'current-user' : ''}`}>
              <div className="message-header">
                {msg.sender}
              </div>
              <div className="message-content">
                {msg.image ? (
                  <div className="message-image-container">
                    <img 
                      src={msg.image} 
                      alt="Message content" 
                      className="message-image"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = 'https://via.placeholder.com/200x150?text=Image+Not+Found';
                      }}
                    />
                  </div>
                ) : null}
                {msg.text && (
                  <div dangerouslySetInnerHTML={{ __html: msg.text }} />
                )}
              </div>
            </div>
          </div>
        ))}
        <div ref={messagesEndRef} />
      </div>
      {renderReplies()}
    </div>
  );
};

export default ChatSimulator; 